export default __webpack_public_path__ + "static/media/WhiteLogo.83a0b999.png";